<div class="fm-ikea-container">
	<div class="fm-ikea-row">
		<div class="fm-ikea-col-md-6 fm-ikea-col-12">
			<h1 class="fm-page-headline">Oops!</h1>
			<p>
				We are so sorry, but an error seem to occur that we can't handle properly
				right now.
			</p>
			<p>
				The problem has been logged and we will do our very best to fix it as soon
				as possible.
			</p>
			<p>
				Meanwhile, you can try to log out of IMCC and then log back on again, this
				can sometimes be a workaround. If you still experience the problem, you're
				always welcome to contact our support team on
				<a href="mailto: support@imcc.systems">support@imcc.systems</a>, we're ready
				to help you.
			</p>
		</div>
		<div class="fm-ikea-col-md-6 fm-ikea-col-12">
			<app-fm-image
				src="../../../../assets/images/unexpected-error.jpg"
				[alt]="'Unexpected error'"
				[fullWidth]="true"
				[prefix]="'fm-'"
			></app-fm-image>
		</div>
	</div>
</div>
